"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isWithError = void 0;
function isWithError(r) {
    return 'error' in r;
}
exports.isWithError = isWithError;
//# sourceMappingURL=types.js.map